<template>
    <div class="addProp-container">
        <div class="addProp-title">
            <h2 :class="{'hideText': step == 4}">{{$t('addProperty.addProp')}}</h2>
        </div>

        <div class="layout-flex">
            <div class="layout-l">
                <addProp1 @goToStep="goToStep" :nationalities="nationalities" v-if="step == 1" />
                <addProp2
                    :property_country_flag="property_country_flag"
                    @goToStep="goToStep"
                    :collection="collection.step1"
                    :requestParams="requestParams"
                    v-if="step == 2"
                />
                <addProp3 @goToStep="goToStep" :collection="collection.step1" v-if="step == 3" />
                <addProp4 @goToPortfolio="viewPortfolio" @goToStep="goToStep" v-if="step == 4" />
            </div>
            <div class="layout-r">
                <div class="property-tip" v-if="step != 4">
                    <h2>{{$t('addProperty.PortfolioTip')}}</h2>
                    <p>{{$t('addProperty.portfolioDeatil')}}</p>
                    <p v-html="$t('addProperty.PortfolioDetail1')"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Message } from "element-ui";
import { Loading } from "element-ui";
import addProp1 from "@/components/account/addProp1.vue";
import addProp2 from "@/components/account/addProp2.vue";
import addProp3 from "@/components/account/addProp3.vue";
import addProp4 from "@/components/account/addProp4.vue";

export default {
    name: "addPropContainer",
    props: [
        "requestParams",
        "requestHeaders",
        "portfolioResp",
        "nationalities"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            step: 1,
            addPropertyUrl: "",
            editPropertyUrl: "",
            collection: {
                step1: {
                    country: "1232"
                },
                step2: {},
                step3: {}
            },
            property_country_flag: ""
        };
    },

    created() {},

    beforeMount() {
        this.initialData();
    },

    activated() {
        this.step = 1;
    },

    methods: {
        initialData() {
            this.addPropertyUrl = `${this.requestParams.ppbApi}api/property/`;
            this.$emit("loaded", true);
        },

        goToStep(child) {
            this.collection[`step${child.step - 1}`] = child.form;
            if (this.collection.step1.country.code2 == "HK") {
                this.property_country_flag = "HK";
            } else if (this.collection.step1.country.code2 == "CN") {
                this.property_country_flag = "CN";
            }

            if (child.step == 3 && this.property_country_flag == "HK") {
                this.collection.step2.building_name =
                    this.$root.cookie.acreage == "en"
                        ? child.form.building_name.ename
                        : child.form.building_name.name;
                this.collection.step2.name =
                    this.$root.cookie.acreage == "en"
                        ? child.form.name.ename
                        : child.form.name.name;
                this.collection.step2.floor_name = child.form.floor_name.floor;
            }

            if (child.step == 4) {
                let paramBody = {};
                for (const i in this.collection) {
                    if (this.collection.hasOwnProperty(i)) {
                        const attr = this.collection[i];
                        for (const key in attr) {
                            if (attr[key] != "" && attr[key] != undefined) {
                                if (key == "country") {
                                    attr["country"] =
                                        attr["country"]["_countryCode"];
                                }
                                paramBody[key] = attr[key].toString();
                            }
                        }
                    }
                }

                const loading = this.$loading({
                    lock: true,
                    target: ".main-container",
                    text: this.$t("addProperty.submitForm"),
                    spinner: "el-icon-loading",
                    background: "rgba(255, 255, 255, 0.8)"
                });
                paramBody.user = this.requestParams.userId;

                this.$http
                    .post(
                        `${this.addPropertyUrl}`,
                        paramBody,
                        this.requestHeaders
                    )
                    .then(resp => {
                        this.$emit("updateAside", "update");
                        this.step = child.step;
                        loading.close();
                    })
                    .catch(error => {
                        loading.close();

                        let errorMsg = "";
                        Object.values(error.data).forEach(it => {
                            errorMsg = it.toString();
                            this.triggerMessage("error", {
                                message: errorMsg
                            });
                        });
                    });
            } else {
                this.step = child.step;
            }
        },

        viewPortfolio(tar) {
            this.$emit("goToPortfolio", "portfolio");
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    components: {
        addProp1,
        addProp2,
        addProp3,
        addProp4
    }
};
</script>
<style lang="scss">
.hideText {
    opacity: 0;
}

.p-relative {
    position: relative;
    .el-input .el-input__inner {
        padding-left: 40px;
    }
    .el-form-item__content {
        margin: 0 !important;
    }
    .el-form-item__label {
        width: 100% !important;
        margin-bottom: 10px;
        float: unset;
        padding: 0;
    }
    .placeholderPend {
        position: absolute;
        top: 0;
        font-size: 14px;
        font-weight: 500;
        color: var(--brownish-grey);
    }
    .prepend {
        left: 16px;
        font-family: GothamBook;
    }
    .append {
        right: 16px;
        font-family: GothamMedium;
    }
}

.addProp-container {
    .addProp-title {
        h2 {
            font-size: 24px;
            line-height: 1.33;
            color: #2e384d;
            margin-bottom: 30px;
        }
    }
    .layout-flex {
        display: flex;
        justify-content: space-between;
        @media (max-width: 768px) {
            width: calc(100% - 73px);
        }
        @media (max-width: 414px) {
            justify-content: unset;
            flex-direction: column;
            width: 100%;
        }
        .layout-l {
            width: 400px;
            @media (max-width: 768px) {
                width: 100%;
                flex-direction: row;
            }
        }
        .layout-r {
            width: 242px;
            margin-right: 100px;
            @media (max-width: 768px) {
                display: none;
            }
            @media (max-width: 414px) {
                display: block;
                width: 100%;
                margin-right: 0;
            }
        }
    }
    .layout-fx {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media (max-width: 768px) {
            &.el-form-item::after,
            &.el-form-item::before {
                content: unset;
            }
            align-items: center;
            display: block;
            flex-direction: unset;
            display: flex;
            justify-content: space-between;

            .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }
    .property-tip {
        position: relative;
        border-radius: 4px;
        padding: 16px 16px 0;
        box-shadow: 0 6px 36px 0 rgba(0, 62, 100, 0.04);
        background-color: #f0f3ff;
        z-index: 5;
        &::after {
            content: "";
            display: inline-block;
            width: 242px;
            height: 196px;
            position: absolute;
            top: 32px;
            left: 32px;
            z-index: -1;
            background: url("../../../../website_20/static/img/pattern-bg.svg")
                no-repeat;
            background-size: contain;
        }
        @media (max-width: 768px) {
            &::after {
                content: unset;
            }
        }
        h2 {
            font-family: GothamMedium;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.21;
            color: #333333;
        }
        p {
            font-family: GothamBook;
            font-size: 12px;
            line-height: 1.2;
            color: #333333;
            padding-bottom: 16px;
            span {
                font-family: GothamMedium;
            }
        }
    }
    .addProp-box {
        .subtitle {
            margin: -10px 0 20px;
            font-family: GothamMedium;
            font-size: 16px;
            font-weight: 500;
            line-height: 1;
            color: #2e384d;
        }
        .el-input {
            &.is-focus {
                .el-input__inner {
                    border: 1px solid var(--windows-blue);
                }
            }
        }
        .el-input__inner {
            background-color: rgba(224, 231, 255, 0.2);
            &:focus {
                border: 1px solid var(--windows-blue);
            }
        }
        .el-radio-group,
        .el-select {
            width: 100%;
        }
        .el-radio {
            border: 1px solid #e0e7ff;
            text-align: center;
            &.normal {
                border: none;
                &.is-checked {
                    background: #fff;
                    .el-radio__label {
                        color: var(--windows-blue);
                    }
                    .el-radio__inner {
                        background-color: var(--windows-blue);
                        color: var(--windows-blue);
                        border-color: var(--windows-blue);
                    }
                }
                .el-radio__label {
                    font-family: GothamBook;
                    font-size: 14px;
                    letter-spacing: -0.1px;
                    text-align: center;
                    color: #606266;
                    padding: 0;
                    &.is-checked {
                    }
                }
                .el-radio__inner {
                    border: 1px solid #dcdfe6;
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    &::after {
                        content: "";
                    }
                }
            }
            .el-radio__label {
                font-family: GothamBook;
                font-size: 14px;
                letter-spacing: -0.1px;
                text-align: center;
                color: var(--windows-blue);
                padding: 0;
            }
            &.is-checked {
                background-color: var(--windows-blue);
                border-color: var(--windows-blue);
                .el-radio__label {
                    color: var(--white);
                }
            }
            .el-radio__inner {
                display: inline;
                width: 0;
                height: 0;
                overflow: hidden;
                border: 0;
                &::after {
                    content: unset;
                }
            }
        }
        .el-input-number {
            @media (min-width: 768px) {
                width: 200px;
            }
            @media (max-width: 414px) {
                width: 150px;
            }
            &.is-focus {
                .el-checkbox__inner {
                    border-color: var(--windows-blue);
                }
            }
        }
        .el-checkbox {
            .el-checkbox__input {
                &.is-focus {
                    .el-checkbox__inner {
                        border-color: var(--windows-blue);
                    }
                }
            }
            &.is-checked {
                .el-checkbox__inner {
                    background: var(--windows-blue);
                    border-color: var(--windows-blue);
                }
                .el-checkbox__label {
                    color: var(--windows-blue);
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            height: auto;
            line-height: normal;
        }
        .el-form--label-left .el-form-item__label {
            padding: 0;
        }

        .el-form-item__label {
            font-family: GothamBook;
            font-size: 14px;
            line-height: 1;
            color: #4a4a4a;
        }
        .type-card {
            .el-radio {
                width: 100%;
                text-align: center;
                padding-left: 0;
                padding-right: 0;
            }
            h4 {
                font-family: GothamMedium;
                font-size: 12.5px;
                line-height: 1.2;
                text-align: center;
                color: var(--windows-blue);
                word-break: break-word;
                white-space: normal;
                @media (max-width: 414px) {
                    margin: 0 30px;
                }
            }
            .type-card-item {
                position: relative;
                height: 110px;
                width: 100%;
                border-radius: 4px;
                margin-bottom: 15px;
                border: solid 1.4px #447ef6;
                background-color: var(--white);
                &.is-checked {
                    background-color: #f2f7ff;
                    position: relative;
                    &::before {
                        content: "";
                        position: absolute;
                        top: 12px;
                        right: 12px;
                        width: 20px;
                        height: 21px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-image: url("../../../../website_20/static/img/UJ/icon-checkmark-blueBGC.svg");
                    }
                }
                &::after {
                    content: "";
                    display: block;
                    height: 32px;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 50%;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                }
                .el-radio__label {
                    display: flex;
                    justify-content: center;
                    width: 100%;
                    padding: 0;
                    margin-top: 50px;
                }
            }
            .el-col:nth-child(1) .type-card-item:after {
                background-image: url("../../../../website_20/static/img/addProp/apartment.svg");
            }
            .el-col:nth-child(2) .type-card-item:after {
                background-image: url("../../../../website_20/static/img/addProp/house.svg");
            }
            .el-col:nth-child(3) .type-card-item:after {
                background-image: url("../../../../website_20/static/img/addProp/townhouse.svg");
            }
            .el-col:nth-child(4) .type-card-item:after {
                background-image: url("../../../../website_20/static/img/addProp/buildings.svg");
            }
        }
        .lh-normal {
            .el-form-item__content {
                line-height: normal;
            }
            .enterTip {
                margin-top: 10px;
                display: inline-block;
                font-family: GothamBok;
                font-size: 12px;
                color: #bc3036;
            }
        }
        .el-button {
            width: 100%;
            background-color: var(--windows-blue);
            border: 0;
        }
        .label-top {
            .el-form-item__label {
                margin-bottom: 10px;
                width: 100% !important;
            }
            .el-form-item__content {
                margin: 0 !important;
            }
        }
        .el-input-number {
            .el-input-number__increase,
            .el-input-number__decrease {
                background-color: rgba(224, 231, 255, 0.2);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/addPropContainer.vue